import React from "react";
import styles from "./relatedNews.module.css";
import PlaceholderImage from "~components/Placeholder";

const RELATED_NEWS_PLACEHOLDER_COUNT = 10;

export const RelatedNewsPlaceholder = () => {
  return (
    <div className={styles.relatedNews}>
      <div className={styles.title}>Related News</div>
      <div className={styles.placeholderContainer}>
        {new Array(RELATED_NEWS_PLACEHOLDER_COUNT)
          .fill(null)
          .map((_, index) => (
            <PlaceholderImage
              key={`RelatedNewsPlaceholder-${index}`}
              className={styles.placeholderItem}
            />
          ))}
      </div>
    </div>
  );
};
